const EVENT_NAME = `${process.env.REACT_APP_CURRENT_YEAR} ${process.env.REACT_APP_EVENT_NAME}`;
const EVENT_NAME_ABRV = `${process.env.REACT_APP_EVENT_NAME_ABRV} ${process.env.REACT_APP_CURRENT_YEAR}`;

export { EVENT_NAME, EVENT_NAME_ABRV };
